.header {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	align-items: center;
	gap: var(--space-3);
	min-height: var(--header-h);
}

.left {
	justify-self: start;
}

.center {
	justify-self: stretch;
	min-width: 0;
	text-align: center;
}

.right {
	justify-self: end;
}
